import { Component, OnDestroy, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { firstValueFrom, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/features/services/auth/auth.service';
import { MyErrorStateMatcher } from 'src/app/shared/app-classes';
import { DataAccessService } from 'src/app/shared/services/data-access.service';
import { ToolsService } from 'src/app/shared/services/tools.service';
import {
  NotificationService,
  NotificationData,
} from 'src/app/shared/services/notification.service';
import { MatDialogRef } from '@angular/material/dialog';
import { LoggingService } from 'src/app/shared/services/Logging.service';
@Component({
  selector: 'app-add-action',
  templateUrl: './add-action.component.html',
  styleUrls: ['./add-action.component.scss'],
  inputs: [
    'suggestName',
    'parent',
    'dialogRef',
    'name',
    'built',
    'actionName',
    'promptList',
    'builtTemplate',
    'intention',
    'isTheme',
    'show',
    'event',
    'action',
    'idBOT',
    'botType',
    'payload',
    'mode',
    'flowName',
  ],
})
export class AddActionComponent implements OnInit, OnDestroy {
  titleForm!: FormGroup;
  dialogRef: any;
  payload: any;
  public mode: any;
  public action: any;
  public id: any;
  public actionName: any;
  public name: any;
  newAct: any;
  idBOT: any;
  flowName: any;
  public actionlist: any;
  public index: any;
  public sousquick: any;
  isTheme;
  matcher = new MyErrorStateMatcher();
  user;
  botType;
  built;
  promptList;
  builtTemplate;
  show;
  rang;
  event;
  intention;
  subUser: any;
  isDisabled: boolean = false;
  isLoading: boolean = false;
  placeholder!: string;
  builtIn!: boolean;
  suggestName!: string;
  parent!: any;
  actName!: string;
  submitted;
  notifications: NotificationData[] = [];
  private destroy$ = new Subject<void>();
  private readonly responseAddedMessage = 'Response added successfully.';

  constructor(
    public DialogRef: MatDialogRef<AddActionComponent>,
    private notificationService: NotificationService,
    private auth: AuthService,
    private tools: ToolsService,
    private afs: AngularFirestore,
    private cas: DataAccessService,
    private loggingService: LoggingService,
  ) {}

  ngOnInit() {
    // Subscribe to notification service
    this.notificationService.notification$
      .pipe(takeUntil(this.destroy$))
      .subscribe((notification) => {
        this.notifications.push(notification);
        setTimeout(() => {
          const index = this.notifications.indexOf(notification);
          if (index > -1) {
            this.notifications.splice(index, 1);
          }
        }, 4000);
      });

    this.subUser = this.auth.getUser()?.subscribe((u) => {
      if (!this.tools.isNullOrUndefined(u)) {
        this.user = u;
      }
    });
    this.actionName = this.flowName || this.name || this.suggestName || '';

    this.titleForm = new FormGroup({
      nameAction: new FormControl(this.actionName, [Validators.required]),
    });
    this.builtIn = this.isTheme === 'themes' ? true : false;
    this.loggingService.log('botType', this.botType);
  }

  private notifyResponseAdded(): void {
    this.notificationService.showAfterDialog(
      'success',
      this.responseAddedMessage,
    );
  }

  private newResponseElement() {
    return {
      type1: 'PLAIN',
      typeResponse: 'message',
      type3: 'text',
      index: 1,
      body: JSON.stringify({ metadata: 'sent from Bot', text: '' }),
    };
  }

  validate(): void {
    if (this.titleForm.valid) {
      this.isDisabled = true;
      this.isLoading = true;
      this.actionName = this.titleForm.value.nameAction.trim();
      const actID = 'PAYLOAD_' + this.actionName.replace(/[^A-Z0-9]+/gi, '_');
      if (!this.name) {
        if (this.parent && this.suggestName) {
          this.afs
            .collection(`${this.isTheme}/${this.idBOT}/actions/`)
            .doc(actID.toUpperCase())
            .ref.get()
            .then((doc) => {
              if (!doc.exists) {
                if (
                  this.botType === 'messenger' ||
                  this.botType === 'instagram' ||
                  this.botType === 'widget-chat'
                ) {
                  this.cas
                    .addAction(
                      this.isTheme,
                      this.idBOT,
                      actID.toUpperCase(),
                      this.actionName,
                      this.built,
                      this.event,
                      this.intention,
                      this.show,
                      this.builtTemplate,
                      this.newResponseElement(),
                    )
                    .then((res) => firstValueFrom(res))
                    .then((newAction) => {
                      this.newAct = newAction;
                      this.isLoading = false;
                      this.isDisabled = false;
                      this.dialogRef?.close?.(this.newAct);
                      this.notifyResponseAdded();
                    })
                    .catch((error) => {
                      this.isLoading = false;
                      this.isDisabled = false;
                      this.notificationService.show(
                        'error',
                        'Error adding fulfillment',
                      );
                    });
                } else {
                  if (!this.actionName.startsWith(this.actName)) {
                    this.parent = null;
                  }
                  this.cas
                    .addfulfilment(
                      this.isTheme,
                      this.idBOT,
                      actID.toUpperCase(),
                      this.actionName,
                      this.built,
                      this.event,
                      this.intention,
                      this.show,
                      this.builtTemplate,
                      {
                        type: 'message',
                        type3: 'response',
                        index: 1,
                        recoMessage: false,
                      },
                      this.promptList,
                      this.parent,
                    )
                    .then((res) => firstValueFrom(res))
                    .then((newAction) => {
                      this.newAct = newAction;
                      this.isLoading = false;
                      this.isDisabled = false;
                      this.dialogRef?.close?.(this.newAct);
                      this.notifyResponseAdded();
                    })
                    .catch((error) => {
                      this.isLoading = false;
                      this.isDisabled = false;
                      this.notificationService.show(
                        'error',
                        'Error adding response',
                      );
                    });
                }
              } else {
                this.isLoading = false;
                this.isDisabled = false;
                this.dialogRef?.close?.(this.newAct);
                this.notificationService.showAfterDialog(
                  'warning',
                  'Existing Fulfillment with the same Name',
                );
              }
            })
            .catch((error) => {
              this.isLoading = false;
              this.isDisabled = false;
              this.notificationService.show(
                'error',
                'Error checking fulfillment',
              );
            });
        } else {
          this.afs
            .collection(`${this.isTheme}/${this.idBOT}/actions/`)
            .doc(actID.toUpperCase())
            .ref.get()
            .then((doc) => {
              if (!doc.exists) {
                if (
                  this.botType === 'messenger' ||
                  this.botType === 'instagram' ||
                  this.botType === 'widget-chat'
                ) {
                  this.cas
                    .addAction(
                      this.isTheme,
                      this.idBOT,
                      actID.toUpperCase(),
                      this.actionName,
                      this.built,
                      this.event,
                      this.intention,
                      this.show,
                      this.builtTemplate,
                      this.newResponseElement(),
                    )
                    .then((res) => firstValueFrom(res))
                    .then((newAction) => {
                      this.newAct = newAction;
                      this.isLoading = false;
                      this.isDisabled = false;
                      this.dialogRef?.close?.(this.newAct);
                      this.notifyResponseAdded();
                    })
                    .catch((error) => {
                      this.isLoading = false;
                      this.isDisabled = false;
                      this.notificationService.show(
                        'error',
                        'Error adding fulfillment',
                      );
                    });
                } else {
                  this.cas
                    .addfulfilment(
                      this.isTheme,
                      this.idBOT,
                      actID.toUpperCase(),
                      this.actionName,
                      this.built,
                      this.event,
                      this.intention,
                      this.show,
                      this.builtTemplate,
                      {
                        type: 'message',
                        type3: 'response',
                        index: 1,
                        recoMessage: false,
                      },
                      this.promptList,
                      null,
                    )
                    .then((res) => firstValueFrom(res))
                    .then((newAction) => {
                      this.newAct = newAction;
                      this.isLoading = false;
                      this.isDisabled = false;
                      this.dialogRef?.close?.(this.newAct);
                      this.notifyResponseAdded();
                    })
                    .catch((error) => {
                      this.isLoading = false;
                      this.isDisabled = false;
                      this.notificationService.show(
                        'error',
                        'Error adding response',
                      );
                    });
                }
              } else {
                this.isLoading = false;
                this.isDisabled = false;
                this.dialogRef?.close?.(this.newAct);
                this.notificationService.showAfterDialog(
                  'warning',
                  'Existing Fulfillment with the same Name',
                );
              }
            })
            .catch((error) => {
              this.isLoading = false;
              this.isDisabled = false;
              this.notificationService.show(
                'error',
                'Error checking fulfillment',
              );
            });
        }
      } else {
        this.cas
          .updateAction(
            this.isTheme,
            this.idBOT,
            this.payload.id,
            this.actionName,
          )
          .then((_) => {
            this.isLoading = false;
            this.isDisabled = false;
            this.dialogRef.close({
              id: this.payload.id,
              name: this.actionName,
            });
          })
          .catch((error) => {
            this.isLoading = false;
            this.isDisabled = false;
            this.notificationService.show('error', 'Error updating action');
          });
      }
    } else {
      this.notificationService.show('warning', 'Make sure your form is valid');
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subUser.unsubscribe();
  }
  onCloseClick() {
    this.DialogRef.close();
  }
}
